<template>
  <app-layout title="Dashboard">
    <template v-slot:sidenav> </template>

    <template v-slot:horizonav>
      <nav-bar :scId="selectedId" :scType="selectedType"> </nav-bar>
    </template>

    <!-- <div>
    {{$session.get("username")}}
     </div> -->    
    <div>Apple</div>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import NavBar from "@/Layouts/NavBar.vue";

export default {
  props: {
    selectedId: String,
    selectedType: String,
  },
  components: {
    AppLayout,
    NavBar,
  },
  data() {
    return {
    
    };
  },

   methods: {

  },
  mounted() {
 

  },
};
</script>

<style>
</style>